import { render, staticRenderFns } from "./OurWorkShowcase.vue?vue&type=template&id=3d36bbfe&"
import script from "./OurWorkShowcase.vue?vue&type=script&lang=js&"
export * from "./OurWorkShowcase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports